angular.module('picmonicng').component('maturityRating', {
  templateUrl: '/templates/app/components/maturity-rating/maturity-rating.html',
  bindings: {
    hideDescription: '@',
  },
  replace: true,
});
